import { render } from "./AiChatWidget.vue?vue&type=template&id=2a56edc8&scoped=true"
import script from "./AiChatWidget.vue?vue&type=script&lang=js"
export * from "./AiChatWidget.vue?vue&type=script&lang=js"

import "./AiChatWidget.vue?vue&type=style&index=0&id=2a56edc8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a56edc8"]])

export default __exports__